import React from 'react';
import { ItemText, ItemWrapper } from './TopicSummary.styles';

const TopicItem = ({ text, needsAttention }) => (
  <ItemWrapper>
    {needsAttention === null ? null : needsAttention ? <span>⚠️</span> : <span>✅</span>}
    <ItemText>{text}</ItemText>
  </ItemWrapper>
);

export default TopicItem;
